<template>
  <div>
    <v-btn
      v-if="!isMember()"
      class="ma-4 js-updaters-toggle-button"
      small
      fab
      dark
      color="secondary"
      @click="showUpdater = !showUpdater"
    >
      <v-icon dark>mdi-pencil</v-icon>
    </v-btn>

    <v-sheet elevation="1" class="pa-1" v-if="showUpdater">
      <via-add :userId="userId" :stats="assessment.areas"></via-add>
    </v-sheet>

    <via-chart :stats="assessment.areas" :reOrderable="true"></via-chart>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import eventMixin from "@/mixins/eventMixin"
import userMixin from "@/mixins/userMixin"
import ViaChart from "@/components/assessments/ViaChart"
import ViaAdd from "@/components/assessments/ViaAdd"

import User from "@/lib/user"
import { mapGetters } from "vuex"
import { AssessmentsAPI } from "@/lib/api"

export default {
  mixins: [titleMixin, eventMixin, userMixin],
  components: { ViaChart, ViaAdd },
  data: function() {
    return {
      title: "Character Strengths",
      userId: this.$route.params.id,
      userType: User.getUserType(),
      assessment: { areas: [] },
      showUpdater: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.userId = to.params.id

      this.$store
        .dispatch("assessments/assessmentsByUserId", {
          userId: this.userId
        })
        .then(() => {
          this.assessment = this.getAssessmentByType("Via") || { areas: [] }
        })
    }
    next()
  },
  created() {
    this.assessment = this.getAssessmentByType("Via") || { areas: [] }

    // listener for add via
    this.addListener("via_result:add", ({ userId, name, value, visible }) => {
      console.log("visible1: " + visible)
      AssessmentsAPI.addVia(userId, name, value, 0, visible).then(() => {
        this.$store
          .dispatch("assessments/assessmentsByUserId", {
            userId: this.userId
          })
          .then(() => {
            this.assessment = this.getAssessmentByType("Via")
          })
      })
    })

    // listener for via sub_order increase
    this.addListener(
      "via_result:increase_sub_order",
      ({ userId, name, value, subOrder, visible }) => {
        AssessmentsAPI.addVia(userId, name, value, subOrder, visible).then(
          response => {
            this.$store
              .dispatch("assessments/assessmentsByUserId", {
                userId: this.userId
              })
              .then(() => {
                this.assessment = this.getAssessmentByType("Via")
              })
          }
        )
      }
    )

    this.addListener("via_result:visibility", ({ visible, userId }) => {
      console.log("via visibility update -- userID: " + userId + " " + visible)
      AssessmentsAPI.updateViaVisibility(userId, visible).then(() => {
        this.$store
          .dispatch("assessments/assessmentsByUserId", {
            userId: this.userId
          })
          .then(() => {
            this.assessment = this.getAssessmentByType("Via")
          })
      })
    })
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>
